import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserDetail,
  userPasswordGenrate,
  userRoleAndParentChange,
} from "reduxStore/action/usersActions";
import { useParams } from "react-router-dom";
import Select from "react-select";
import strings from "translate/language";
import {
  getAge,
  isEmpty,
  seo,
  handleListResponse,
  handleDetailResponse,
} from "utils/utils";
import {
  AdminRoleId,
  BusinessHead,
  CallCenter,
  ClusterHead,
  HR,
  PostSale,
  Receptionist,
  SiteHead,
  SubAdmin,
  SupportRequest,
  genderCheck,
} from "utils/constants";
import moment from "moment";
import Breadcrumb from "component/common/breadcrumb";

import { getRoleList } from "reduxStore/action/roleActions";
import { getUserFilterDetail } from "reduxStore/action/usersActions";
import { getActivePropertys } from "reduxStore/action/chatActions";
import {
  ChannelPartner,
  CPAgent,
  ClosingManager,
  SourcingManager,
  SourcingTL,
  ClosingTL,
} from "utils/constants";
import { universalRemoveAction } from "reduxStore/action/authActions";
import {
  GET_ACTIVE_PROPERTY_LIST,
  USER_ROLE_AND_PARENT_CHANGE,
} from "reduxStore/types";
import { removeModalClass } from "utils/modalHandler";
import usePermission from "utils/usePermission";
const ViewUser = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const { user_id = "" } = params || {};
  const [formVaild, setFormVaild] = useState({});
  const [form, setForm] = useState({});
  const [userList, setUserList] = useState([]);
  const [rolesList, setRolesList] = useState([]);
  const [activeProperties, setActiveProperties] = useState([]);
  const [isHeadTL, setIsHeadTL] = useState(false);
  const [isPropertyAllocate, setIsPropertyAllocate] = useState(false);
  const [profileDetail, setProfileDetail] = useState({});
  const getRoleListSelector = useSelector((state) => state.roleData);
  const userListSelector = useSelector((state) => state.userData);
  const chatSelector = useSelector((state) => state.chatResponse);
  const loginSelector = useSelector((state) => state.login);

  const { edit } = usePermission({
    edit: "edit_user",
  });

  useEffect(() => {
    const { response } = getRoleListSelector;
    if (response) {
      if (response?.status === 200) {
        let filterData = handleListResponse(response.data).filter(
          (i) =>
            i._id !== CPAgent &&
            i._id !== ChannelPartner &&
            i._id !== HR &&
            i._id !== PostSale &&
            i._id !== Receptionist &&
            i._id !== CallCenter &&
            i._id !== SubAdmin &&
            i._id !== SupportRequest
        );
        setRolesList(filterData);
      } else {
        setRolesList([]);
      }
    }
  }, [getRoleListSelector]);
  useEffect(() => {
    const { activeProperties } = chatSelector;
    if (activeProperties) {
      if (activeProperties?.status === 200) {
        setActiveProperties(handleListResponse(activeProperties?.data));
      } else {
        setActiveProperties([]);
      }
    }
  }, [chatSelector]);

  const handleInputField = (e) => {
    var nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
      propertyObj: [],
    };
    if (e.target.name === "role_id") {
      nextFormState = {
        ...form,
        isHeadTL: "",
        [e.target.name]: e.target.value,
      };
    }
    dispatch(
      getActivePropertys({
        user_id: e.target.value,
      })
    );

    dispatch(
      getUserFilterDetail({
        limit: 500,
        offset: 0,
      })
    );

    setForm(nextFormState);
  };
  const handleValid = () => {
    let err = {};
    let formError = false;
    if (!form.role_id) {
      formError = true;
      err["role_id"] = strings.role_idErr;
    }
    if (!form.isHeadTL) {
      formError = true;
      err["is_head_tl"] = strings.parentErr;
    } else if (form.isHeadTL === strings.selectParent) {
      formError = true;
      err["is_head_tl"] = strings.parentErr;
    }
    if (form.propertyObj?.length === 0 || form.propertyObj === undefined) {
      formError = true;
      err["propertyObj"] = strings.propertyErr;
    }
    if (!isEmpty(err)) {
      formError = true;
    }
    setFormVaild(err);
    return formError;
  };
  const handleChangeRole = () => {
    if (!handleValid()) {
      let params = {
        role_id: form.role_id,
        user_id: user_id,
        property_id: null,
        parent_id: null,
      };
      if (!isEmpty(form?.propertyObj)) {
        params.property_id = form?.propertyObj.map((i) => i._id);
      }
      if (!isEmpty(form?.isHeadTL)) {
        params.parent_id = form?.isHeadTL;
      }
      dispatch(userRoleAndParentChange(params));
    }
  };
  useEffect(() => {
    seo({
      title: "User Details",
      metaDescription: "View user details",
      canonicalLink: window.location.href,
    });
  }, []);
  useEffect(() => {
    dispatch(getUserDetail({ user_id }));
    dispatch(getRoleList());
  }, [dispatch, user_id]);

  useEffect(() => {
    const { userData, roleChange, create, detail } = userListSelector;
    if (userData) {
      if (userData?.status === 200) {
        const list = handleListResponse(userData?.data).filter((el) => {
          return form.role_id === ClosingManager
            ? el?.role_id === ClosingTL
            : form.role_id === SourcingManager
              ? el?.role_id === SourcingTL
              : form.role_id === ClosingTL || form.role_id === SourcingTL
                ? el?.role_id === SiteHead ||
                el?.role_id === ClusterHead ||
                el?.role_id === BusinessHead ||
                el?.role_id === AdminRoleId
                : form.role_id === SiteHead
                  ? el?.role_id === ClusterHead ||
                  el?.role_id === BusinessHead ||
                  el?.role_id === AdminRoleId
                  : form.role_id === ClusterHead
                    ? el?.role_id === BusinessHead || el?.role_id === AdminRoleId
                    : form.role_id === BusinessHead
                      ? el?.role_id === AdminRoleId
                      : "";
        });
        // setUserList(handleListResponse(userData?.data));
        setUserList(list);
      } else {
        setUserList([]);
      }
    }
    if (roleChange) {
      dispatch(universalRemoveAction(USER_ROLE_AND_PARENT_CHANGE));
      dispatch(universalRemoveAction(GET_ACTIVE_PROPERTY_LIST));
      if (isPropertyAllocate) {
        removeModalClass("propertyAllocate");
        setIsPropertyAllocate(false);
      } else {
        removeModalClass("roleChange");
      }
      dispatch(getUserDetail({ user_id }));
    }
    if (create) {
      if (userData?.status === 200) {
        setForm({});
        dispatch(getUserDetail({ user_id }));
      }
    }
    if (detail) {
      if (userData?.status === 200) {
        const data = handleDetailResponse(userData.data);
        setProfileDetail(data);
        setForm({
          role_id: data?.role_id,
          sourcing_head: data?.sourcing_head,
          isHeadTL: data?.sourcing_head,
          parentUser: handleDetailResponse(
            userList.filter((i) => i._id === data?.sourcing_head)
          ),
        });
        // if (
        //   data?.sourcing_head !==
        //   handleDetailResponse(loginSelector.response?.data)._id &&
        //   data?.sourcing_head &&
        //   !isEmpty(data?.parent_name)
        // ) {
        let obj = {
          [SourcingManager]: SourcingTL,
          [ClosingManager]: ClosingTL,
        };
        dispatch(
          getActivePropertys({
            user_id: data?.sourcing_head,
          })
        );
        dispatch(
          getUserFilterDetail({
            offset: 0,
            role_id: obj[data?.role_id],
          })
        );
        setIsHeadTL(true);
        // }
      }
    }
  }, [dispatch, userListSelector, form.role_id]);

  const handlePassword = () => {
    if (!isEmpty(user_id)) {
      dispatch(userPasswordGenrate({ user_id: user_id }));
    }
  };

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.userDetails}
        url={"/user"}
        parentListing={strings.userListing}
        titleactive={strings.viewuserdetails}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 card">
            <div className="row">
              <div className="col-md-4">
                <div>
                  <div className="card-header">
                    <h5 className="">{strings.profile}</h5>
                  </div>
                  <label
                    htmlFor="exampleInputMobileNo"
                    className="boldText"
                  ></label>
                  <img
                    src={
                      profileDetail?.profile_picture
                        ? profileDetail?.base_url +
                        profileDetail?.profile_picture
                        : "/assets/images/user.png"
                    }
                    alt={profileDetail?.firstname}
                    width="200"
                    height="200"
                    className="center"
                  />
                </div>
                {edit && (
                  <div className="mt-5 text-center">
                    {/* <div className="col mt-3">
                      <a
                        aria-hidden="true"
                        title={strings.roleChange}
                        data-toggle="modal"
                        data-original-title="test"
                        data-target="#roleChange"
                        className="breadcrumb-item"
                        style={{ color: "#4466f2" }}
                        onClick={() => {
                          var nextFormState = {
                            ...form,
                            propertyObj: [],
                          };
                          setForm(nextFormState);
                          setIsHeadTL(true);
                          dispatch(
                            getUserFilterDetail({
                              limit: 500,
                              offset: 0,
                            })
                          );
                        }}
                      >
                        {strings.roleChange}
                      </a>
                    </div> */}
                    <div className="col mt-3">
                      <a
                        aria-hidden="true"
                        title={strings.userPasswordSend}
                        data-toggle="modal"
                        data-original-title="test"
                        data-target="#exampleModal"
                        className="breadcrumb-item"
                        style={{ color: "#4466f2" }}
                      >
                        {strings.userPasswordSend}
                      </a>
                    </div>
                    {/* <div className="col mt-3">
                      <a
                        aria-hidden="true"
                        title={strings.propertyAllocate}
                        data-toggle="modal"
                        data-original-title="test"
                        data-target="#propertyAllocate"
                        onClick={() => {
                          setIsPropertyAllocate(true);
                          dispatch(
                            getActivePropertys({
                              user_id: profileDetail?.sourcing_head,
                            })
                          );
                        }}
                        className="breadcrumb-item"
                        style={{ color: "#4466f2" }}
                      >
                        {strings.propertyAllocate}
                      </a>
                    </div> */}
                  </div>
                )}
              </div>
              <div className="col-md-8">
                <div className="card-header row justify-content-sm-between">
                  <h5>{strings.userDetails}</h5>
                </div>
                <div className="card-body">
                  <div className="tabbed-card">
                    <ul
                      className="nav nav-pills nav-primary"
                      id="pills-clrtabinfo"
                      role="tablist"
                    >
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          id="pills-clrprofile-tabinfo"
                          data-toggle="pill"
                          href="#pills-clrprofileinfo"
                          role="tab"
                          aria-controls="pills-clrprofile"
                          aria-selected="false"
                        >
                          {strings.userInfo}
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          id="pills-clrhome-tabinfo"
                          data-toggle="pill"
                          href="#pills-clrhomeinfo"
                          role="tab"
                          aria-controls="pills-clrhome"
                          aria-selected="true"
                        >
                          {strings.stats}
                        </a>
                      </li>
                    </ul>
                    <div className="tab-content" id="pills-clrtabContentinfo">
                      <div
                        className="tab-pane fade"
                        id="pills-clrhomeinfo"
                        role="tabpanel"
                        aria-labelledby="pills-clrhome-tabinfo"
                      >
                        <div className="row">
                          <div className="col-md-4 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.noOfBooking} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {profileDetail?.user_states?.total_booking || 0}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-4 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.noOfCloseVisit} :
                            </label>
                          </div>

                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {profileDetail?.user_states?.total_closing_lead ||
                                0}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-4 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.closingPercentage} :
                            </label>
                          </div>

                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {profileDetail?.user_states
                                ?.total_closing_percentage
                                ? Number(
                                  profileDetail?.user_states?.total_closing_percentage.replace(
                                    "%",
                                    ""
                                  )
                                ).toFixed(2) + "%"
                                : strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-4 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.lastLogin} :
                            </label>
                          </div>

                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {profileDetail?.user_states?.last_login
                                ? moment(
                                  profileDetail?.user_states?.last_login
                                ).format("DD-MM-yyyy hh:mm a")
                                : strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-4 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.lastVisitAttend} :
                            </label>
                          </div>

                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {profileDetail?.user_states?.last_site_visit
                                ? moment(
                                  profileDetail?.user_states?.last_site_visit
                                ).format("DD-MM-yyyy hh:mm a")
                                : strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-4 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.lastBooking} :
                            </label>
                          </div>

                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {profileDetail?.user_states?.last_booking
                                ? moment(
                                  profileDetail?.user_states?.last_booking
                                ).format("DD-MM-yyyy hh:mm a")
                                : strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-4 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.lastCloseVisit} :
                            </label>
                          </div>

                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {profileDetail?.user_states?.last_closing_lead
                                ? moment(
                                  profileDetail?.user_states
                                    ?.last_closing_lead
                                ).format("DD-MM-yyyy hh:mm a")
                                : strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                      </div>
                      <div
                        className="tab-pane fade show active"
                        id="pills-clrprofileinfo"
                        role="tabpanel"
                        aria-labelledby="pills-clrprofile-tabinfo"
                      >
                        <div className="row">
                          <div className="col-md-3 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.justoEmp} :
                            </label>
                          </div>

                          <div className="col-md-7 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                              style={{ textTransform: "capitalize" }}
                            >
                              {profileDetail?.justo_employee_code ||
                                strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-3 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.firstName} :
                            </label>
                          </div>

                          <div className="col-md-7 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                              style={{ textTransform: "capitalize" }}
                            >
                              {profileDetail?.firstname || strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-3 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.lastName} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                              style={{ textTransform: "capitalize" }}
                            >
                              {profileDetail?.lastname || strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-3 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.createdDate} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {profileDetail?.created_date
                                ? moment(profileDetail?.created_date).format(
                                  "DD-MM-yyyy hh:mm a"
                                )
                                : strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-3 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.emailAddress} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {profileDetail?.email || strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-3 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.mobileNo} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {profileDetail?.mobile || strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-3 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.aadharNo} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {profileDetail?.adhar_no || strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-3 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.pancardNo} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {profileDetail?.pancard_no ||
                                strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-3 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.gender} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {genderCheck[profileDetail?.gender] ||
                                strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-3 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.age} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {profileDetail?.dateofbirth
                                ? getAge(profileDetail?.dateofbirth)
                                : strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-3 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.parentname} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                              style={{ textTransform: "capitalize" }}
                            >
                              {profileDetail?.parent_name ||
                                strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-3 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.role} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {profileDetail?.role_title ||
                                strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-3 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.city} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {profileDetail?.city || strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-3 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.address} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                              style={{ textTransform: "capitalize" }}
                            >
                              {profileDetail?.address || strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-3 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.area} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {profileDetail?.area || strings.notavailable}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-3 align-items-center mt-2">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.projectsName} :
                            </label>
                          </div>
                          <div className="col-md-7 align-items-center mt-2">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {profileDetail?.allocated_property &&
                                profileDetail?.allocated_property.length > 0 ? (
                                <div>
                                  <label
                                    htmlFor="exampleInputMobileNo"
                                    className="boldText"
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    {profileDetail?.allocated_property
                                      ?.map((item) => item?.property_title)
                                      .join(", ")}
                                  </label>
                                </div>
                              ) : (
                                strings.notavailable
                              )}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Model_start */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {strings.password}
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="text-center">
                <h6>{strings.areYouSure}</h6>
              </div>
              <div className="text-center">
                <h6>{strings.youWantChangePassword}</h6>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                className="btn btn-success mr-5"
                type="button"
                onClick={() => handlePassword()}
                data-dismiss="modal"
              >
                {strings.yes}
              </button>
              <button
                className="btn btn-primary"
                type="button"
                data-dismiss="modal"
              >
                {strings.no}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Role Change Modal */}
      <div
        className="modal fade"
        id="roleChange"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {strings.roleChange}
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label htmlFor="exampleFormControlSelect9">
                      {strings.role}
                      <span className="required-field"></span>
                    </label>
                    <select
                      className="form-control digits"
                      name="role_id"
                      value={form.role_id}
                      onChange={handleInputField}
                    >
                      <option value="">{strings.selectRole}</option>
                      {rolesList.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.role_title}
                        </option>
                      ))}
                    </select>
                    {formVaild?.role_id && (
                      <span style={{ color: "red" }}>{formVaild?.role_id}</span>
                    )}
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="mb-3">
                    <label htmlFor="exampleFormControlSelect9">
                      {strings.parent}
                      <span className="required-field"></span>
                    </label>
                    <select
                      className="form-control digits"
                      name="isHeadTL"
                      value={form.isHeadTL}
                      onChange={handleInputField}
                    >
                      <option value="">{strings.selectParent}</option>
                      {userList.map((item, index) => (
                        <option key={index} value={item._id}>
                          {`${item.firstname} ${item.lastname} (${item?.role_title})`}
                        </option>
                      ))}
                    </select>
                    {formVaild?.is_head_tl && (
                      <span style={{ color: "red" }}>
                        {formVaild?.is_head_tl}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="mt-3">
                    <label htmlFor="exampleFormControlSelect9">
                      {strings.property}
                      <span className="required-field"></span>
                    </label>
                    <Select
                      isSearchable
                      isMulti
                      isClearable
                      options={activeProperties}
                      getOptionLabel={(option) => `${option.property_title}`}
                      getOptionValue={(option) => option._id}
                      name="propertyObj"
                      value={form?.propertyObj}
                      onChange={(val) => {
                        const nextFormState = {
                          ...form,
                          propertyObj: val,
                        };
                        setForm(nextFormState);
                      }}
                    />
                    {formVaild?.propertyObj && (
                      <span style={{ color: "red" }}>
                        {formVaild?.propertyObj}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                className="btn btn-success mr-5"
                type="button"
                onClick={() => handleChangeRole()}
              >
                {strings.update}
              </button>
              <button
                className="btn btn-primary"
                type="button"
                data-dismiss="modal"
              >
                {strings.cancel}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Property Allocate Modal */}
      <div
        className="modal fade"
        id="propertyAllocate"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {strings.propertyAllocate}
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="col-md-12">
                <div className="mb-1">
                  <label htmlFor="exampleInputMobileNo">
                    {strings.allocatedProps} :-
                  </label>
                </div>
                <label htmlFor="exampleInputMobileNo" className="boldText">
                  {profileDetail?.allocated_property &&
                    profileDetail?.allocated_property.length > 0 ? (
                    <div>
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                        style={{ textTransform: "capitalize" }}
                      >
                        {profileDetail?.allocated_property
                          ?.map((item) => item?.property_title)
                          .join(", ")}
                      </label>
                    </div>
                  ) : (
                    strings.notavailable
                  )}
                </label>
              </div>
              <hr />
              <div className="col-md-12">
                <div className="mb-3">
                  <label htmlFor="exampleFormControlSelect9">
                    {strings.property}
                    <span className="required-field"></span>
                  </label>
                  <Select
                    isSearchable
                    isMulti
                    isClearable
                    options={activeProperties}
                    getOptionLabel={(option) => `${option.property_title}`}
                    getOptionValue={(option) => option._id}
                    name="propertyObj"
                    value={form?.propertyObj}
                    onChange={(val) => {
                      const nextFormState = {
                        ...form,
                        propertyObj: val,
                      };
                      setForm(nextFormState);
                    }}
                  />
                  {formVaild?.propertyObj && (
                    <span style={{ color: "red" }}>
                      {formVaild?.propertyObj}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                className="btn btn-success mr-5"
                type="button"
                onClick={() => handleChangeRole()}
              >
                {strings.update}
              </button>
              <button
                className="btn btn-primary"
                type="button"
                data-dismiss="modal"
              >
                {strings.cancel}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Model_end */}
    </div>
  );
};
export default ViewUser;
